import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { insertSchema } from '../../@schema/insertSchema'

export function useFormAgendamento({ numeroNota, infoProposta, onSend, agendarRetorno, onSubmitSuccess }) {
  const methods = useForm({
    resolver: zodResolver(insertSchema),
  })

  const { setValue } = methods

  useEffect(() => {
    setValue('numero_nota', numeroNota)
    setValue('codigo_parceiro', infoProposta?.cliente?.codigo_parceiro)
    setValue('codigo_contato', infoProposta?.codigo_contato)
    setValue('numero_pedido', infoProposta?.numero_pedido)
    setValue('agendamentoRetorno', 'EMAIL')
  }, [setValue, numeroNota, infoProposta])

  const onSubmit = async (data) => {
    const params = {
      ...data,
      assunto_email: data.assunto_email ? `Proposta de Fornecimento: ${infoProposta?.numero_pedido} - Innovation Brindes ${data.assunto_email}` : '',
      numero_nota: numeroNota,
      codigo_parceiro: infoProposta?.cliente?.codigo_parceiro,
      codigo_contato: infoProposta?.codigo_contato,
      numero_pedido: infoProposta?.numero_pedido,
      data_agendamento: `${data.dataRetorno} ${data.horaRetorno}`,
      observacoes: data.observacoes,
      tipo_agendamento: data.agendamentoRetorno,
      conteudo_retorno: data.mensagem,
      enviar_proposta: onSend ? true : false,
    }

    if (onSend) {
      onSend()
    }

    await agendarRetorno.mutateAsync(params)
    if (onSubmitSuccess) {
      onSubmitSuccess()
    }
  }

  return {
    methods,
    handleSubmit: () => methods.handleSubmit(onSubmit)(),
    onChangeSelect: (value) => setValue('agendamentoRetorno', value),
    agendamentoTipo: methods.watch('agendamentoRetorno') ?? 'EMAIL',
  }
}
